import { Factory } from 'rosie';

Factory.define('GuidePerformanceView');

Factory.define('GuidePerformanceViewWithDefaults')
  .extend('GuidePerformanceView')
  .attr('name', 'GUIDE_PERFORMANCE_VIEW')
  .attr('dateRange', '1d')
  .attr('pageNumber', 1);
